import { $getSupplierParameters } from "../requests"

import { ActionTypes } from "./act_types"
import { getUserRole, getTranslationsByScope, DropitState } from "../reducers"
import { toastr } from "react-redux-toastr"
import { responseType, transform } from "../../utils/http-res-handler"

export const fetchSupplierParameters =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    const role = getUserRole(getState())

    return $getSupplierParameters(role)
      .then((res) =>
        transform(
          res,
          getTranslationsByScope(getState(), "toastrLabels"),
          responseType.json
        )
      )
      .then((response: any) => {
        dispatch({
          supplierParameters: response,
          type: ActionTypes.UPDATE_SUPPLIER_PARAMETERS,
        })
      })
      .catch((err) => {
        toastr.error(
          err.message ? err.message : "Impossible de contacter le server.",
          ""
        )
        return err
      })
  }
